import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '赛事分类',
    links: [
      { to: '/category/caodi-jingji', label: '草地竞技' },
      { to: '/category/caoyuan-saidai', label: '草园赛道' },
      { to: '/category/ludi-taofa', label: '绿地挑战' },
      { to: '/category/zonghe-saishi', label: '综合赛事' },
    ],
  },
  {
    title: '学习资源',
    links: [
      { to: '/category/xinren-rumen', label: '新人入门' },
      { to: '/category/gaoji-jijie', label: '高级技巧' },
      { to: '/article/xinren-rumen-wu-da-jichu', label: '基础动作详解' },
      { to: '/article/caodi-jingji-anquan-shouze', label: '安全守则' },
    ],
  },
  {
    title: '关于平台',
    links: [
      { to: '/about', label: '品牌介绍' },
      { to: '/about', label: '用户口碑' },
      { to: '/about', label: '联系我们' },
      { to: '/article/2026-q3-paihangbang-jiexi', label: '排行榜' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 no-underline mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-plant-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50 whitespace-nowrap">一起草</span>
            </Link>
            <p className="text-sm text-secondary-300 leading-relaxed">
              一起草每日大赛 — 专为草类竞技爱好者打造的每日在线赛事平台。
              每天开启全新挑战，公平竞技，实时排名。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">{group.title}</h4>
              <ul className="flex flex-col gap-2">
                {group.links.map((link) => (
                  <li key={link.to + link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-secondary-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-secondary-400">
            &copy; 2026 一起草每日大赛. 保留所有权利.
          </p>
          <div className="flex items-center gap-4 text-secondary-400">
            <a href="#" className="text-sm hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-sm hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">服务条款</a>
            <a href="#" className="text-sm hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}